import { html } from "lit";
var icon_video_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="1.7" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <path
        d="M28.133 27.267c0 .957-.776 1.733-1.733 1.733H5.6a1.733 1.733 0 0 1-1.733-1.733V4.733C3.867 3.776 4.643 3 5.6 3h17.333c.452 0 .887.177 1.21.492l3.467 3.332c.335.326.523.773.523 1.24v19.203Z" />
      <path
        d="M13.964 21.096a.99.99 0 0 1-1.43-.885v-6.689a.99.99 0 0 1 1.43-.885l6.69 3.346a.988.988 0 0 1 0 1.768l-6.69 3.345Z" />
    </g>
  </svg>
`;
export {
  icon_video_default as default
};
//# sourceMappingURL=icon-video.js.map
